import { render, staticRenderFns } from "./PrizeFramePicture.vue?vue&type=template&id=4a276047&scoped=true&"
import script from "./PrizeFramePicture.vue?vue&type=script&lang=js&"
export * from "./PrizeFramePicture.vue?vue&type=script&lang=js&"
import style0 from "./PrizeFramePicture.vue?vue&type=style&index=0&id=4a276047&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a276047",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a276047')) {
      api.createRecord('4a276047', component.options)
    } else {
      api.reload('4a276047', component.options)
    }
    module.hot.accept("./PrizeFramePicture.vue?vue&type=template&id=4a276047&scoped=true&", function () {
      api.rerender('4a276047', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/luckydraw/components/PrizeFramePicture.vue"
export default component.exports